const dateValidations = require('./date');
const detailValidations = require('./detail');
const fileValidations = require('./file');
const floatValidations = require('./float');
const maskValidations = require('./masked');
const multiselectValidations = require('./multiselect');
const nftLinkValidations = require('./nftLink');
const numberValidations = require('./number');
const selectValidations = require('./select');
const selectimageValidations = require('./selectimage');
const stringValidations = require('./string');
const polygonValidations = require('./polygon');
const locationValidations = require('./location');
const boxTargetValidations = require('./boxTarget');

const currentValidations = {
  date: { ...dateValidations },
  detail: { ...detailValidations },
  file: { ...fileValidations },
  float: { ...floatValidations },
  masked: { ...maskValidations },
  multiselect: { ...multiselectValidations },
  nft_link: { ...nftLinkValidations },
  number: { ...numberValidations },
  select: { ...selectValidations },
  selectimage: { ...selectimageValidations },
  text: { ...stringValidations },
  polygon: { ...polygonValidations },
  location: { ...locationValidations },
  boxTarget: { ...boxTargetValidations },
};

/**
 * export all the functions for a type of field
 * @param {String} fieldType
 * @returns {object} the validations for the current type
 */
const getTypeValidations = (fieldType) => {
  const validations = currentValidations[fieldType];
  return validations !== undefined ? validations : {};
};

module.exports = { getTypeValidations };
